export const modifyMemberInfoCn = {
    xunjiadang:'会员信息',
    touxiang:'头像',
    nicheng:'昵称',
    zhengshixingming:'会员姓名',
    xingbie:'性别',
    nan:'男',
    nv:'女',
    zhuzhudi:'居住地',
    qingxuanzhe:'请选择',
    xiangxidizhi:'详细地址',
    shoujihaoma:'手机号码',
    youxiang:'邮箱',
    weixinhao:'微信号',
    yibanding:'已绑定',
    weibangding:'未绑定',
    jiebang:'解绑',
    huiyuanxinxixiougai:'会员信息 - 修改审核',
    fanhui:'返回',
    niyichenggong:'您已成功上传相关资料，我们将在7个工作日内进行审核！'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/modifyMemberInfo/modifyMemberInfoCn.js